const dateSlicer = (dateString) => {
    // converting Coordinated Universal Time i.e. UTC
    // recieved from MongoDB to date format as
    // 2022-08-02T07:31:28.000Z
    const strToDate = new Date(dateString);

    // converting date to local time in string format as
    // Thu Jul 21 2022 19:36:32 GMT+0530 (India Standard Time)
    const localTime = strToDate.toString();

    // IF localTime = "Thu Jul 21 2022 19:36:32 GMT+0530 (India Standard Time)";
    // THEN slicedDate = Jul 21 2022, 19:36 Hrs.
    const slicedDate = `${localTime.slice(4, 15)}, ${localTime.slice(16, 21)} Hrs.`;

    return slicedDate;
}

export default dateSlicer;